import React from 'react';

/*
    - ihoDesignSystem
*/
import { Box, Image, Typography } from '@iho-design-system/Loader';

/*
    - icons
*/
import InfoSVG from '../../../assets/images/help-desk/info.svg';
import UserSVG from '../../../assets/images/help-desk/user.svg';

const RemoveRequest = ({ requestType }) => {

    return (

        <React.Fragment>

            {requestType.split(',')[3] === 'removeRequestFinished' &&
                <React.Fragment>
                    <Box
                        className={`w-100 my-sm`} />
                    <Box
                        className={`d-flex flex-wrap align-item-start justify-content-end position-relative`}
                        ms={{
                            opacity: '0',
                            bottom: '-16px',
                            animation: 'chatAnimation 0.25s linear',
                            animationFillMode: 'forwards'
                        }}>
                        <Box
                            className={`px-md py-xs rounded-sm rounded-bottom-left-0`}
                            ms={{
                                maxWidth: '60%',
                                backgroundColor: 'var(--gray-dark)'
                            }}>
                            <Typography
                                className={`d-block`}
                                ms={{
                                    color: 'var(--white)'
                                }}>
                                حذف درخواست
                            </Typography>
                        </Box>
                        <Box
                            className={`mx-xs ml-0 my-sm mb-0 rounded-circle`}>
                            <Image
                                src={UserSVG}
                                alt='info'
                                ms={{
                                    width: '18px',
                                    height: '18px'
                                }} />
                        </Box>
                    </Box>
                    <Box
                        className={`w-100 my-sm`} />
                    <Box
                        className={`d-flex flex-wrap align-item-start position-relative`}
                        ms={{
                            opacity: '0',
                            bottom: '-16px',
                            animation: 'chatAnimation 0.25s linear',
                            animationFillMode: 'forwards',
                            animationDelay: '0.5s'
                        }}>
                        <Box
                            className={`p-xs mx-xs mr-0 my-sm mb-0 rounded-circle`}
                            ms={{
                                maxWidth: '60%',
                                backgroundColor: 'var(--gray-medium)'
                            }}>
                            <Image
                                src={InfoSVG}
                                alt='info'
                                ms={{
                                    width: '12px',
                                    height: '12px'
                                }} />
                        </Box>
                        <Box
                            className={`px-md py-xs rounded-sm rounded-bottom-right-0 toggle-opaccity`}
                            ms={{
                                maxWidth: '60%',
                                backgroundColor: 'var(--gray-medium)'
                            }}>
                            <Typography>
                                درخواست شما با موفقیت حذف گردید.
                            </Typography>
                        </Box>
                    </Box>
                </React.Fragment>
            }

        </React.Fragment>

    );

}

export default RemoveRequest;